<template>
  <div class="modal">
    <div class="modal-dialog" style="width: 1800px; height: 100px">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ dataTransPorter }}</h4>
          <button type="button" class="btn btn-lg" v-on:click="tutupModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <v-list style="height: 450px">
            <v-simple-table style="height: 100%; overflow-y: auto">
              <template v-slot:default>
                <tbody>
                  <tr v-for="item in dataObjek" :key="item.nomor_do">
                    <td>
                      <v-list-item two-line>
                        <template>
                          <div
                            class="bg-primary"
                            style="
                              padding: 10px;
                              margin-right: 20px;
                              border-radius: 50px;
                            "
                          >
                            <v-icon
                              color="danger lighten-1"
                              style="color: white"
                            >
                              mdi-check
                            </v-icon>
                          </div>

                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.nomor_do"
                            ></v-list-item-title>

                            <v-list-item-subtitle
                              class="text-primary"
                              v-text="item.customer"
                            ></v-list-item-subtitle>

                            <v-list-item-subtitle
                              v-text="item.tujuan"
                            ></v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action style="margin-left: -30px">
                            <v-list-item-action-text
                              style="color: black"
                              v-text="rupiah(item.nominal)"
                            ></v-list-item-action-text>
                            <v-icon
                              class="text-danger"
                              @click="hapus(item.tms_klaim_detail_id)"
                              >mdi-trash-can-outline</v-icon
                            >
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-list>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            v-on:click="tutupModal()"
          >
            <!-- <v-icon class="text-white">mdi-trash-can-outline</v-icon> -->
            Close
          </button>
          <button type="button" class="btn btn-primary" v-on:click="cetak">
            Cetak PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import axios from "axios";

export default {
  name: "ModalComp",
  components: {},
  data() {
    return {
      nom: this.rupiah(90),
    };
  },
  props: ["dataObjek", "dataTransPorter", "namaTransporter", "dibuat"],
  computed: {},
  methods: {
    tutupModal() {
      this.$emit("tutupModal", false);
    },
    batalkan(c) {
      if (!confirm(`Batalkan pengajuan ini ?`)) {
        return;
      }
      axios
        .post(`https://services.ama.id/eloading/batalkan`, {
          tms_klaim_detail_id: c,
        })
        .then((res) => {
          console.log(res);
        });
    },
    hapus(v) {
      // return
      if (!confirm(`Yakin ingin menghapus ?`)) {
        return;
      }

      axios
        .post(`https://services.ama.id/eloading/deleteDO`, {
          tms_klaim_detail_id: v,
        })
        .then((res) => {
          let objek = res.data;
          // console.log(objek);
          if (objek.respone_code == "200") {
            this.$emit("loadsData", false);
            this.tutupModal();
            alert(`Berhasil..`);
          }
        })
        .catch(function (error) {
          // this.loading = false
          console.log(error);
        });
      console.log(v);
    },
    cetak() {
      let tbl = [];
      let obj = this.dataObjek;
      console.log(obj);
      let tinggi = 70;
      let nominal = 0;
      let biaya_lain = 0;
      for (let i = 0; i < obj.length; i++) {
        tinggi = tinggi + 15;
        nominal = nominal + obj[i].nominal;
        biaya_lain = biaya_lain + obj[i].biaya_lain;
        tbl.push([
          obj[i].nomor_do,
          obj[i].customer + "\n" + obj[i].alamat,
          obj[i].kendaraan ? obj[i].kendaraan : "",
          obj[i].tonase ? this.rupiah(obj[i].tonase) : "",
          this.rupiah(obj[i].nominal),
          this.rupiah(obj[i].biaya_lain) +
            `\n ${obj[i].catatan ? "[" + obj[i].catatan + "]" : ""}`,
        ]);
      }
      const doc = new jsPDF();
      doc.setFont("helvetica");
      doc.text(
        "TRANSPORTER MANAGEMENT KLAIM",
        doc.internal.pageSize.getWidth() / 2,
        20,
        { align: "center" }
      );
      doc.autoTable({
        startY: 30,
        body: [
          [
            "Nomor Dokumen",
            ":",
            this.dataTransPorter,
            "Nominal",
            ":",
            this.rupiah(nominal),
          ],
          [
            "Transporter",
            ":",
            this.namaTransporter,
            "Biaya Lain",
            ":",
            this.rupiah(biaya_lain),
          ],
          [
            "Tgl Pengajuan",
            ":",
            this.dibuat,
            "Total Biaya",
            ":",
            this.rupiah(biaya_lain + nominal),
          ],
        ],
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 5 },
          2: { cellWidth: 70 },
          3: { cellWidth: 20 },
          4: { cellWidth: 5 },
          5: { cellWidth: 40 },
        },
      });

      doc.setFontSize(9);
      doc.text("Daftar Nomor Surat Jalan :", 15, 63);
      doc.autoTable({
        startY: 65,
        head: [
          [
            "Surat Jalan",
            "Customer",
            "Kendaraan",
            "Tonase",
            "Nominal",
            "Biaya Lain",
          ],
        ],
        body: tbl,
        theadStyles: {
          fontSize: 20,
        },
        columnStyles: {
          0: { cellWidth: 33, fontSize: 7 },
          1: { cellWidth: 55, fontSize: 7 },
          2: { cellWidth: 22, fontSize: 7 },
          3: { cellWidth: 20, fontSize: 7 },
          4: { cellWidth: 25, fontSize: 7 },
          5: { cellWidth: 25, fontSize: 7 },
        },
      });
      doc.output("dataurlnewwindow");
      // Save the PDF
      // doc.save("data.pdf");
    },
    rupiah(v) {
      var bilangan = v;
      // console.log(bilangan," duitt...");
      if (bilangan.toString().includes("-")) {
        // bilangan = bilangan.substring(1)
      }
      var reverse = bilangan.toString().split("").reverse().join(""),
        ribuan = reverse.match(/\d{1,3}/g);
      ribuan = ribuan.join(".").split("").reverse().join("");

      return ribuan;
    },
  },
};
</script>
  <style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
</style>
  